export enum JoinSessionStatus {
    Pending = "pending",
    Consumed = "consumed",
    Invalidated = "invalidated",
    Expired = "expired",
}
